/**
 * TW Ingredients — mobile accordion; desktop keeps all rows expanded.
 */
(function () {
  const MQ_DESKTOP = window.matchMedia('(min-width: 750px)');

  function syncSection(sectionEl) {
    const detailsList = sectionEl.querySelectorAll('.tw-ingredients-panel__item-details');
    detailsList.forEach((details) => {
      if (MQ_DESKTOP.matches) {
        details.setAttribute('open', '');
        details.classList.add('tw-ingredients-panel__item-details--desktop');
      } else {
        details.classList.remove('tw-ingredients-panel__item-details--desktop');
        if (!details.hasAttribute('data-user-toggled')) {
          details.removeAttribute('open');
        }
      }
    });
  }

  function bindSection(sectionEl) {
    if (sectionEl.dataset.twIngredientsAccordionBound === 'true') return;
    sectionEl.dataset.twIngredientsAccordionBound = 'true';

    sectionEl.querySelectorAll('.tw-ingredients-panel__item-details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!MQ_DESKTOP.matches) {
          details.setAttribute('data-user-toggled', 'true');
        }
      });
    });

    const onMqChange = () => syncSection(sectionEl);
    if (MQ_DESKTOP.addEventListener) {
      MQ_DESKTOP.addEventListener('change', onMqChange);
    } else {
      MQ_DESKTOP.addListener(onMqChange);
    }

    syncSection(sectionEl);
  }

  function init() {
    document.querySelectorAll('.tw-ingredients-section-wrapper').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('tw-ingredients-section-wrapper')) {
      bindSection(event.target);
    }
  });

  document.addEventListener('tw-ingredients:content-swapped', (event) => {
    const sectionEl = event.target.closest
      ? event.target.closest('.tw-ingredients-section-wrapper')
      : null;
    if (sectionEl) {
      delete sectionEl.dataset.twIngredientsAccordionBound;
      bindSection(sectionEl);
    }
  });
})();
